import { FeatureDefinition } from '../entities';

export const trialEndPaymentWhatsappExperiment = 'appnebula_trial_end_payment_test_whatsapp';

export enum TrialEndPaymentWhatsappExperimentGroups {
  CONTROL = 'control',
  TEST = 'test',
}

export const trialEndPaymentWhatsappExperimentConfig: FeatureDefinition = {
  defaultValue: TrialEndPaymentWhatsappExperimentGroups.CONTROL,
};
